import { GameFreeSpinsOverlayProperties } from "@lib/js-slingo-pawnshop-core/dist";
/**
 * FreeSpinsOverlayLandscapeProperties.ts
 */
export class FreeSpinsOverlayLandscapeProperties extends GameFreeSpinsOverlayProperties {
    setDefaultValues() {
        super.setDefaultValues();
    }
}
